import React, { useState, useEffect, useRef, useContext } from "react";
import Cookies from "js-cookie";
// import ServiceApi from "../../../../services/ServiceApi";
import {
  Cover,
  Status,
  Stationmap,
  // Station,
  Site,
  Detail,
  Stoptime,
  Smshistory,
  Checkalarm,
  Progress,
  EventEndTime ,
  // TotalTime,
  // Sparepart,
  Nodesite,
  SiteAccess
} from "../../../../components/uih/full_detail_job";
// import LayoutOperation from "../../../../components/layout_operation";
import { authUserContext } from "../../../../contexts/authContext";

const teamEnableJobProgress = ["19", "101", "102", "123"];

function OnprocessDetail({
  CompanyId,
  OperatorId,
  ProjectId,
  ProjectData,
  headerdata,
  Jobdata,
  Workflowdata,
  factUpdate,
  LangTranslate,
}) {
  const authUserValue = useContext(authUserContext);
  const locale = Cookies.get("locale");
  const [FlowStep, setFlowStep] = useState(1);
  const [currentPage, setcurrentPage] = useState(0);
  const [isActive, setisActive] = useState(0);
  const [Smsdata, setSmsdata] = useState([]);
  const [showFixdProblemDetail, setshowFixdProblemDetail] = useState(false);
  const [showFormFixdProblemDetail, setshowFormFixdProblemDetail] =
    useState(false);
  const [showJobprogress, setshowJobprogress] = useState(false);
  const [showFormJobprogress, setshowFormJobprogress] = useState(false);
  const [showFormMapFixed, setshowFormMapFixed] = useState(false);
  const [showMapFixed, setshowMapFixed] = useState(false);
  const [showAcceptanceDetail, setshowAcceptanceDetail] = useState(false);
  const [showAcceptanceForm, setshowAcceptanceForm] = useState(false);
  const [statusBarStep, setstatusBarStep] = useState(0);
  const [stationSite, setstationSite] = useState({
    depart: {},
    terminal: {},
    effected: {},
    departnode: {},
    terminalnode: {},
  });
  const unmounted = useRef(false);

  /* Get all Language */
  useEffect(() => {
    function CheckData() {
      if (Jobdata.result_sms_list && Jobdata.result_sms_list.length > 0) {
        setSmsdata(Jobdata.result_sms_list);
      }
      if (Jobdata.result_site_detail) {
        Jobdata.result_site_detail.map((data, index) => {
          if (data.job_site_typeId === 1) {
            setstationSite((stationSite) => ({
              ...stationSite,
              depart: Jobdata.result_site_detail[index],
            }));
          } else if (data.job_site_typeId === 2) {
            setstationSite((stationSite) => ({
              ...stationSite,
              terminal: Jobdata.result_site_detail[index],
            }));
          }
        });
      }

      /* setFlowStep */
      if (headerdata && headerdata.subprocessid) {
        const subprocessId = Number(headerdata.subprocessid);
        const mainprocessid = Number(headerdata.main_process_id);
        const { company_id, operator_id } = headerdata;
        // console.log("headerdata", headerdata);

        // first teamEnableJobProgress
        // if (
        //   company_id === 3 &&
        //   teamEnableJobProgress.includes(authUserValue.teamId)
        // ) {
        setFlowStep(2);
        setshowFormJobprogress(true);
        setshowJobprogress(true);
        // }

        // ackjob > depart
        if (
          mainprocessid === 3 &&
          (subprocessId === 10 || subprocessId === 12)
        ) {
          setstatusBarStep(0);
          setFlowStep(2);
          setisActive(1);
          setcurrentPage(1);
          setshowFormJobprogress(true);
          setshowJobprogress(true);
        }
        //depart > onsite
        if (mainprocessid === 3 && (subprocessId === 3 || subprocessId === 9)) {
          setstatusBarStep(1);
          setFlowStep(2);
          setisActive(1);
          setcurrentPage(1);
          setshowFormJobprogress(true);
          setshowJobprogress(true);
        }
        // onsite > accident point
        if (
          mainprocessid === 3 &&
          (subprocessId === 23 || subprocessId === 25)
        ) {
          setstatusBarStep(2);
          setFlowStep(2);
          setisActive(1);
          setcurrentPage(1);
          setshowFormJobprogress(true);
          setshowJobprogress(true);
        }
        if (
          mainprocessid === 3 &&
          (subprocessId === 24 || subprocessId === 26)
        ) {
          setstatusBarStep(3);
          setFlowStep(2);
          setisActive(1);
          setcurrentPage(1);
          setshowFormJobprogress(true);
          setshowJobprogress(true);
        }

        if (
          mainprocessid === 3 &&
          (subprocessId === 27 || subprocessId === 28)
        ) {
          setstatusBarStep(4);
          setFlowStep(2);
          setisActive(1);
          setcurrentPage(1);
          setshowJobprogress(true);
          // if (
          //   company_id === 3 &&
          //   operator_id === 3 &&
          //   teamEnableJobProgress.includes(authUserValue.teamId)
          // ) {
          setshowFormJobprogress(true);
          // }
        }
        if (mainprocessid === 3 && subprocessId === 29) {
          setstatusBarStep(5);
          setFlowStep(3);
          setisActive(2);
          setcurrentPage(2);
          setshowJobprogress(true);
          setshowFormFixdProblemDetail(true);
          // if (
          //   company_id === 3 &&
          //   operator_id === 3 &&
          //   teamEnableJobProgress.includes(authUserValue.teamId)
          // ) {
          // setisActive(1);
          setshowFormJobprogress(true);
          // }
        }
        if (mainprocessid === 3 && subprocessId === 32) {
          setstatusBarStep(6);
          setFlowStep(6);
          setisActive(5);
          setcurrentPage(5);
          setshowJobprogress(true);
          setshowFixdProblemDetail(true);
          setshowMapFixed(true);
          setshowAcceptanceDetail(true);
          // if (
          //   company_id === 3 &&
          //   operator_id === 3 &&
          //   teamEnableJobProgress.includes(authUserValue.teamId)
          // ) {
          // setisActive(1);
          setshowFormJobprogress(true);
          // }
        }
        if (mainprocessid === 3 && subprocessId === 33) {
          setstatusBarStep(6);
          setFlowStep(4);
          setisActive(3);
          setcurrentPage(3);
          setshowJobprogress(true);
          setshowFixdProblemDetail(true);
          setshowFormMapFixed(true);
          setshowAcceptanceDetail(true);
          // if (
          //   company_id === 3 &&
          //   operator_id === 3 &&
          //   teamEnableJobProgress.includes(authUserValue.teamId)
          // ) {
          // setisActive(1);
          setshowFormJobprogress(true);
          // }
        }
        if (mainprocessid === 3 && subprocessId === 30) {
          setstatusBarStep(6);
          setFlowStep(6);
          setisActive(2);
          setcurrentPage(2);
          setshowJobprogress(true);
          setshowFixdProblemDetail(true);
          setshowMapFixed(true);
          setshowAcceptanceDetail(true);
        }

        if (mainprocessid === 3 && subprocessId === 36) {
          setstatusBarStep(6);
          setFlowStep(5);
          setisActive(4);
          setcurrentPage(4);
          setshowJobprogress(true);
          setshowFixdProblemDetail(true);
          setshowMapFixed(true);
          setshowAcceptanceForm(true);
        } // เพิ่มตรวจรับงาน
        if (
          (mainprocessid === 3 &&
            (subprocessId === 34 || subprocessId === 35)) ||
          (mainprocessid === 31 && subprocessId === -1)
        ) {
          setstatusBarStep(7);
          setFlowStep(7);
          setisActive(6);
          setcurrentPage(6);
          setshowJobprogress(true);
          setshowFixdProblemDetail(true);
          setshowMapFixed(true);
          setshowAcceptanceDetail(true);
        }
        if (
          (mainprocessid === 36 && subprocessId === -1) ||
          (mainprocessid === 999 && subprocessId === -1)
        ) {
          setstatusBarStep(7);
          setFlowStep(7);
          setisActive(0);
          setcurrentPage(0);
          setshowJobprogress(true);
          setshowFixdProblemDetail(true);
          setshowMapFixed(true);
          setshowAcceptanceDetail(true);
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }
    CheckData();
    return () => {
      unmounted.current = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [headerdata.job_id]);
  return (
    <>
      {/* <LayoutOperation></LayoutOperation> */}
      <div
        className="wrapper-header-bbtec"
        // style={{ height: "284px" }}
      >
        <div className="container-fluid">
          <Cover
            CompanyId={CompanyId}
            OperatorId={OperatorId}
            ProjectId={ProjectId}
            ProjectData={ProjectData}
            language={LangTranslate}
            factupdate={factUpdate}
            Jobno={headerdata.job_no}
            jobStatusName={headerdata.job_status_name}
            jobTypeName={headerdata.job_type_name}
            jobPriority={Jobdata}
            Jobdata={Jobdata}
            Jobdetail={headerdata}
            workflow={Workflowdata}
          ></Cover>

          <Status CurrentSteps={statusBarStep}></Status>

          <div className="wrapper-body">
            <div className="row">
              <div className="d-flex align-content-md-start flex-wrap w-100">
                <div
                  id="container-left"
                  className="col col-12 col-lg-4 order-1 order-lg-0"
                >
                  {currentPage === 0 ? (
                    <>
                      {Jobdata.result_site_detail &&
                      Jobdata.result_site_detail.length > 0
                        ? Jobdata.result_site_detail.map((data, i) => {
                            if (data.job_site_typeId === 1) {
                              return (
                                <>
                                  <div
                                    className=""
                                    key={`stationmap_data_index_${i}`}
                                  >
                                    <Stationmap
                                      title={
                                        factUpdate
                                          ? LangTranslate[locale][
                                              "start_station"
                                            ]
                                          : null
                                      }
                                      language={
                                        factUpdate ? LangTranslate : null
                                      }
                                      factupdate={
                                        factUpdate ? factUpdate : null
                                      }
                                      locale={locale}
                                      data={stationSite.depart}
                                    ></Stationmap>
                                  </div>
                                  {Jobdata.result_node_detail &&
                                  Jobdata.result_node_detail.length > 0
                                    ? Jobdata.result_node_detail.map(
                                        (data, index) => {
                                          return (
                                            <Nodesite
                                              key={`nodesite_data_index_${index}`}
                                              data={data}
                                              title={
                                                factUpdate
                                                  ? LangTranslate[locale][
                                                      "node_site"
                                                    ]
                                                  : null
                                              }
                                            ></Nodesite>
                                          );
                                        }
                                      )
                                    : null}
                                </>
                              );
                            } else if (data.job_site_typeId === 2) {
                              return (
                                <>
                                  <div className="">
                                    <Stationmap
                                      key={`stationmap_data_index_${i}`}
                                      title={
                                        factUpdate
                                          ? LangTranslate[locale][
                                              "stop_station"
                                            ]
                                          : null
                                      }
                                      language={LangTranslate}
                                      factupdate={factUpdate}
                                      data={stationSite.terminal}
                                    ></Stationmap>
                                  </div>
                                </>
                              );
                            }
                          })
                        : null}
                      <div className="">
                        <Site
                          title={
                            factUpdate
                              ? LangTranslate[locale]["effected_site"]
                              : null
                          }
                          language={LangTranslate}
                          factupdate={factUpdate}
                          headerdata={headerdata}
                          Jobdata={Jobdata}
                        ></Site>

                    <SiteAccess
                          title={"Site ACCESS"
                          }
                          language={LangTranslate}
                          factupdate={factUpdate}
                          headerdata={headerdata}
                          Jobdata={Jobdata}
                        ></SiteAccess>
                      </div>
                    </>
                  ) : null}
                  {currentPage === 1 ? (
                    <>
                      <div className="">
                        <Stoptime
                          title={
                            factUpdate
                              ? LangTranslate[locale]["stop_time_section"]
                              : null
                          }
                          language={LangTranslate}
                          factupdate={factUpdate}
                          CompanyId={CompanyId}
                          OperatorId={OperatorId}
                          ProjectId={ProjectId}
                          headerdata={headerdata}
                          Jobdata={Jobdata}
                          Workflowdata={Workflowdata}
                          canEditstart={true}
                          canEditend={true}
                        ></Stoptime>
                      </div>
                      <div className="">
                        <Smshistory
                          title={
                            factUpdate
                              ? LangTranslate[locale]["sms_alarm_site"]
                              : null
                          }
                          language={LangTranslate}
                          factupdate={factUpdate}
                          smsdata={Smsdata}
                        ></Smshistory>
                      </div>
                      <div className="">
                        <Checkalarm
                          title={
                            factUpdate
                              ? LangTranslate[locale]["alarm_network"]
                              : null
                          }
                          CompanyId={CompanyId}
                          OperatorId={OperatorId}
                          ProjectId={ProjectId}
                          headerdata={headerdata}
                          Jobdata={Jobdata}
                        ></Checkalarm>


                        <EventEndTime
                          title={
                            factUpdate
                              ? "Dtac Event End Time"
                              : null
                          }
                          CompanyId={CompanyId}
                          OperatorId={OperatorId}
                          ProjectId={ProjectId}
                          headerdata={headerdata}
                          Jobdata={Jobdata}
                        ></EventEndTime>
                      </div>
                    </>
                  ) : null}
                  {currentPage >= 2 ? (
                    <>
                      <div>
                        <Progress
                          language={LangTranslate}
                          factupdate={factUpdate}
                          locale={locale}
                          title={
                            factUpdate
                              ? LangTranslate[locale]["progress"]
                              : null
                          }
                          Jobdata={Jobdata}
                          litemode={true}
                        ></Progress>
                      </div>
                    </>
                  ) : null}
                </div>
                <div
                  id="container-right"
                  className="col col-12 col-lg-8 order-0 order-lg-1"
                >
                  <Detail
                    flowStep={FlowStep}
                    headerdata={headerdata}
                    setcurrentPage={setcurrentPage}
                    CompanyId={CompanyId}
                    OperatorId={OperatorId}
                    ProjectId={ProjectId}
                    Jobdata={Jobdata}
                    Workflowdata={Workflowdata}
                    language={LangTranslate}
                    factupdate={factUpdate}
                    setshowFixdProblemDetail={setshowFixdProblemDetail}
                    showFixdProblemDetail={showFixdProblemDetail}
                    showFormFixdProblemDetail={showFormFixdProblemDetail}
                    setshowFormFixdProblemDetail={setshowFormFixdProblemDetail}
                    showJobprogress={showJobprogress}
                    setshowJobprogress={setshowJobprogress}
                    showFormJobprogress={showFormJobprogress}
                    setshowFormJobprogress={setshowFormJobprogress}
                    showFormMapFixed={showFormMapFixed}
                    setshowMapFixed={setshowMapFixed}
                    showMapFixed={showMapFixed}
                    setshowFormMapFixed={setshowFormMapFixed}
                    showAcceptanceDetail={showAcceptanceDetail}
                    setshowAcceptanceDetail={setshowAcceptanceDetail}
                    showAcceptanceForm={showAcceptanceForm}
                    setshowAcceptanceForm={setshowAcceptanceForm}
                    isActive={isActive}
                    setisActive={setisActive}
                  ></Detail>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OnprocessDetail;
